import React from 'react';
import './App.css';
import MnemonicChecker from './MnemonicChecker';

function App() {
  return (
    <div className="App">
      <MnemonicChecker />
    </div>
  );
}

export default App;